import React, { useContext } from 'react';
import { Breadcrumbs } from '@thd-olt-component-react/breadcrumbs';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { InstantCheckoutProvider as NewInstantCheckoutProvider, InstantCheckoutInfo, InstantCheckoutAddressSection, InstantCheckoutPaymentSection, } from '@thd-olt-component-react/instant-checkout-myaccount-preferences';
import { CustomerAccountNavigation, useAccountCrumbs, } from '@thd-olt-component-react/customer-account-navigation';
import { ExperienceContext, useConfigService, } from '@thd-nucleus/experience-context';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { useInterceptors } from '../hooks/use-interceptors';
import { Alert } from '../components/shared/alert/alert';
import { PageTitle } from '../components/shared/page-title';
import { InstantCheckoutContent } from '../components/instant-checkout/instant-checkout-content/instant-checkout-content';
import { InstantCheckoutProvider } from '../contexts/instant-checkout-context';
import { getReCaptchaKey } from '../utils/general';
import { mapCrumbsToStaticCrumbs, } from '../utils/breadcrumbs';
import { useCustomerInfo } from '../hooks/use-customerInfo';
import { useGetRecaptchaToken } from '../hooks/use-get-recaptcha-token';
const crumbs = [
    {
        label: 'Instant Checkout',
        path: '/myaccount/payments/instant-checkout',
    },
];
const InstantCheckoutPageContent = () => {
    const { redirectError } = useInterceptors();
    const { isConsumerApp } = useContext(ExperienceContext);
    const { userID, svocID } = useCustomerInfo();
    const isInstantCheckoutHarmonyExperienceEnabled = useConfigService('isInstantCheckoutHarmonyExperienceEnabled');
    const staticCrumbs = mapCrumbsToStaticCrumbs(useAccountCrumbs(crumbs));
    const isRecaptchaEnabled = !!useConfigService('B2C_PROFILE_INVISIBLE_RECAPTCHA_ENABLED');
    const { getRecaptchaToken } = useGetRecaptchaToken(isRecaptchaEnabled);
    return (React.createElement("div", { className: "grid isBound" },
        React.createElement("div", { className: "col__12-12" }, redirectError ? (React.createElement("div", { className: "sui-pt-8" },
            React.createElement(Alert, { status: "info" }, redirectError.message))) : (React.createElement(InstantCheckoutProvider, null,
            React.createElement("div", { className: "sui-grid sui-gap-3 sui-py-3" },
                !isConsumerApp && (React.createElement(ErrorBoundary, { name: "breadcrumbs" },
                    React.createElement(Breadcrumbs, { staticCrumbs: staticCrumbs }))),
                React.createElement(PageTitle, { title: "INSTANT CHECKOUT", dataTestId: "ic-title" })),
            React.createElement("div", { className: "sui-grid sui-grid-cols-12 sui-gap-5 sui-py-3" },
                React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-3" },
                    React.createElement(ErrorBoundary, { name: "customer-account-navigation" },
                        React.createElement(CustomerAccountNavigation, null))),
                React.createElement("div", { className: "sui-col-span-12 lg:sui-col-span-9" },
                    React.createElement(ErrorBoundary, { name: "instant-checkout-content" }, !isInstantCheckoutHarmonyExperienceEnabled ? (React.createElement(InstantCheckoutContent, null)) : (React.createElement(NewInstantCheckoutProvider, { userId: userID, customerAccountId: svocID },
                        React.createElement("div", { className: "sui-gap-8 sui-flex sui-flex-col" },
                            React.createElement(InstantCheckoutInfo, { getRecaptchaToken: getRecaptchaToken }),
                            React.createElement("div", { className: "sui-gap-12 sui-flex sui-flex-col" },
                                React.createElement(InstantCheckoutAddressSection, null),
                                React.createElement(InstantCheckoutPaymentSection, null)))))))))))));
};
InstantCheckoutPageContent.dataModel = extend(CustomerAccountNavigation, Breadcrumbs);
InstantCheckoutPageContent.displayName = 'InstantCheckoutPageContent';
export const InstantCheckout = () => {
    const isRecaptchaEnabled = !!useConfigService('B2C_PROFILE_INVISIBLE_RECAPTCHA_ENABLED');
    if (isRecaptchaEnabled) {
        return (React.createElement(GoogleReCaptchaProvider, { useEnterprise: true, reCaptchaKey: getReCaptchaKey() },
            React.createElement(QueryProvider, { defaultVariables: {
                    channelId: 1,
                }, cacheKey: "instant-checkout-page" },
                React.createElement(InstantCheckoutPageContent, null))));
    }
    return (React.createElement(QueryProvider, { defaultVariables: {
            channelId: 1,
        }, cacheKey: "instant-checkout-page" },
        React.createElement(InstantCheckoutPageContent, null)));
};
InstantCheckout.displayName = 'InstantCheckout';
